export enum PartnerBrand {
  LOTTOMATICA = 'lottomatica',
  BETTER = "better",
  TOTOSI = 'totosi',
  PWO = 'pwo',
  GOLDBET = 'goldbet',
  PWO_2 = "planetwin365"
}
